import { T } from '@tribeplatform/react-components/i18n'

import { WhiteLabelSettings } from '../WhiteLabelSettings/WhiteLabelSettings.js'

export function CommunityWhiteLabelSettingsRouter() {
  return <WhiteLabelSettings />
}

export function CommunityWhiteLabelSettingsBreadCrumb() {
  return <T id="Settings.WhiteLabel" defaultMessage="White Label" />
}
